import { faEye } from '@fortawesome/free-regular-svg-icons';
import { hideWhenReadOnlyRule } from '../commonRules';
import { ErrandInformationModal } from './ErrandInformationModal';
export const ErrandInformationButton = {
    key: 'ärende information',
    text: 'Visa ärendeuppgifter',
    prio: 11,
    section: 'middle',
    icon: faEye,
    buttonStyle: 'default-1',
    ModalComponent: ErrandInformationModal,
    onClick: async (row, inca, showModal)=>{
        // do not validate for reviewers
        await showModal();
    },
    defaultRules: [
        hideWhenReadOnlyRule
    ]
};
